import { Splide, SplideSlide } from '@splidejs/react-splide';
import { IonicButton } from 'ionic-ui';
import React from 'react';
import '@splidejs/react-splide/css';

const slides = [
  {
    title: 'Discounts on meds',
    text: 'Get 20% off this week',
    onClick: () => {},
  },
  {
    title: 'Living Healthy made Easy',
    text: 'Get access to your favourite shops and pharmacy anytime, anywhere',
  },
  {
    title: 'Fast and Reliable',
    text: 'Order medicines with quick delivery at your doorstep',
  },
  {
    title: 'Track Your Health',
    text: 'Easily monitor prescriptions and medical history',
  },
];

export default function DiscountCard() {
  const [activeIndex, setActiveIndex] = React.useState(0);

  return (
    <div className="bg-[url(/images/hero.png)] bg-[100%] rounded-md">
      <div className="bg-opacity-70 bg-[#081d27] text-white rounded-md p-6 text-center">
        <Splide
          options={{
            type: 'loop',
            autoplay: true,
            interval: 3000,
            arrows: false,
            pagination: false, // disable default dots
          }}
          onMoved={(_, newIndex) => setActiveIndex(newIndex)}
        >
          {slides.map((slide, index) => (
            <SplideSlide key={index}>
              <div>
                <h4 className="text-lg font-bold mt-8 mb-2">{slide.title}</h4>
                <p className="mb-4">{slide.text}</p>
                {slide.onClick && (
                  <IonicButton className="bg-white text-black px-4 py-2 rounded font-semibold">
                    Claim discount
                  </IonicButton>
                )}
              </div>
            </SplideSlide>
          ))}
        </Splide>

        {/* Custom SVG Pagination */}
        <div className="mt-4 flex justify-center">
          <svg
            width={slides.length * 12 + 10}
            height="6"
            viewBox={`0 0 ${slides.length * 12 + 10} 6`}
            xmlns="http://www.w3.org/2000/svg"
          >
            {slides.map((_, i) => {
              const isActive = i === activeIndex;
              return (
                <rect
                  key={i}
                  x={i * 12}
                  width={isActive ? 17 : 6}
                  height="6"
                  rx="3"
                  fill={isActive ? '#00C59E' : 'white'}
                  style={{ transition: 'all 0.3s ease' }}
                />
              );
            })}
          </svg>
        </div>
      </div>
    </div>
  );
}
